<template>


<div id="login_page" class="joinus_pages">
	<md-dialog-prompt
      :md-active.sync="password_active"
      v-model="email"
      md-title="איפוס סיסמה"
      md-input-placeholder="הזן את המייל שלך"
      @md-confirm="onConfirmPass()"
      md-confirm-text="שלח" 
      md-cancel-text="בטל"/>
    <a class="logo logo_pink" id="main_logo" href="">
		<span>איכות לכל המשפחה</span>
	</a>

	<div class="join_content"><div class="bg"></div>
<div class="inner" id="step_1">

	<div class="title">התחברות</div>
	<div class="short_text">עוד רגע אנחנו בפנים</div>
	
	<div v-if="!show_step_b">
        <div id="dvAjax_signupFRM" class="mtr">
        <form v-on:submit.prevent="login_do()" method="post" >
        <ul class="frmUL">
            <li class=""><label class="caption"> <span class="mustChar">*</span></label><span class="field"><input pattern="[a-zA-Z0-9._%+-]+@[a-zA-z0-9.-]+\.[a-zA-z]{2,4}$" type="text" value="" placeholder="כתובת מייל"  v-model="info.username" name="username"></span><span style="color:red"></span></li>
            <li class=""><label class="caption"> <span class="mustChar">*</span></label><span class="field"><input type="password" placeholder="סיסמה" name="password"  v-model="info.password"></span><span style="color:red"></span></li>
            <li class="sbm_area "><input class="btn" type="submit" value="התחבר"></li>
        </ul>
        <span id="pass" @click="password_active = true">שכחתי סיסמא</span>
        <div>עדיין אינך רשום? <a :href="'https://www.tov.tv/joinus?plan=19'+linktoregister">להרשמה לחץ כאן</a></div>
        </form>
        
        <form @submit.prevent="sms_login()">
          <h3>או - הקלד את מספר הטלפון הנייד שאיתו נרשמת לאתר:</h3>
          <ul class="frmUL">
                <li class=""><label class="caption"> <span class="mustChar">*</span></label><span class="field"><input id="phone_inp" type="number" name="phone" placeholder="מספר טלפון" ref="phone" required=""></span><span style="color:red"></span></li>
                <li class="sbm_area "><input class="btn" type="submit" value="התחבר בSMS"></li>
            </ul> 
        </form>

        </div>
    </div>

    <div v-if="show_step_b">
    <h3>אנא הזן את הקוד שקיבלת כעת למכשירך</h3>
    <form @submit.prevent="sms_login_confirm()">
        <input id="code_inp" type="number" name="code" placeholder="קוד" ref="code" required="" value="" style="display:block'margin: 15px 0;">
        <div><input type="submit" class="btn" value="הכנס"></div>
    </form>
    </div>


</div>
    
</div>
	<div class="clr"></div>
	
</div>
</template>

<script>
export default {
  data() {
    return {
      password_active:false,
      email:'',
      link:'https://www.tov.tv/signup/forgotPass?email=',
        info: {
            username: '',
            password: ''
        },
        token: '',
        show_step_b: false,
        is_loading: false,
      fromnews: this.$route.params.news,
      prevRoute: `${this.$route.params.prevpage}?t=`,
      linktoregister: (this.$route.params.news === 'news')?"&is_pay=1":"",
      // linktoregister: this.$route.params.news,
          };
    
  },
  methods: {
     onConfirmPass(){
      var self = this;
      this.api_call({ url: 'password_reset', data:{ email: this.email} ,onComplete: function(data){
        self.status = data.data.data
     if(self.status)
        {
          // alert(self.link + self.email); 
          window.location.href = ''+self.link + self.email+'';

          // alert("נשלח אליך למייל קישור לאיפוס סיסמא")
       
        }
        else{
          alert("המייל לא נמצא במערכת")
        }
       
      }})
    },
      login_do(){
            // categories
            this.$http.post(window.api_url + 'login',  JSON.stringify(this.info) ).then(function(data){
                if (data.data.data == false) 
                {
                    alert('הפרטים שהזנת אינם נכונים. אנא תקן ונסה שנית.');
                }
                else
                {
                  
                    localStorage.setItem('user_token', data.data.data);
                   
                  if(this.fromnews === "news"){
                        document.location = 'https://news.tov.tv/'+ this.prevRoute + data.data.data;
                      //  document.location = 'https://news.tov.tv/התחברות-דף-מעבר?t='+ data.data.data;
                  }else{
                        
                        document.location = '/';

                  }
                      

                  // let win = document.getElementById('ifr').contentWindow;
                  // let msg = {"token": data.data.data};
                   //   win.postMessage(msg, "https://tov.tv");
                  // win.postMessage("dddd", "*");
                 
                }

				
            });

      },

    sms_login()
    {
      var self = this;
      self.is_loading = true;
      this.api_call({ url: 'login_phone', data:  {phone: this.$refs.phone.value}, onComplete: function(data){

          self.is_loading = false;
          if (data.data.data != false)
          {
            self.token = data.data.data;
            self.show_step_b = true;
          }
          else alert('פרטי ההתחברות אינם נכונים.');
        }});
    },
    sms_login_confirm()
    {
      var self = this;
      self.is_loading = true;
     // var self = this;
      this.api_call({ url: 'login_confirm', data:  {code: this.$refs.code.value, token: this.token}, onComplete: function(data){

          if (data.data.data != false)
          {
            localStorage.setItem('user_token', data.data.data);
            document.location = '/';
          }
          else 
          {
            alert('פרטי ההתחברות אינם נכונים.');
            self.is_loading = false;
          }
        }});
    }

  }
  
}
</script>


<style scoped>
#pass{font-size: 20px; margin: 10px 0; text-decoration: underline; display: block; cursor: pointer;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}

</style>

